
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { IContactColumnsForDropdown } from '@shared/services/api/legacy/contactcolumns-service/contactcolumns-model';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';

@Injectable()
export class ContactColumnsService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${ContactColumnsService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/contactcolumns';

    public getContactColumnsForDropdown(): Observable<SuccessResponse<IContactColumnsForDropdown> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<IContactColumnsForDropdown>>(ContactColumnsService.URL + '/dropdown').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getContactColumnsForInvitationsDropdown(): Observable<SuccessResponse<IContactColumnsForDropdown> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<IContactColumnsForDropdown>>(ContactColumnsService.URL + '/dropdown/invitations').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

}
